import { Flex, Spinner } from "@chakra-ui/react";

const PageSpinner = () => (
  <Flex w="100vw" h="100vh" justify={"center"} align="center">
    <Spinner />
  </Flex>
);
export default PageSpinner;
